import cn from "classnames";
import { TableBodyProps } from "./types";
import styles from "./styles.module.scss";

export const TableBody = ({
  children,
  className,
  dataTestId = "table-body",
  ...restProps
}: TableBodyProps) => (
  <tbody
    className={cn(styles["table-body"], className)}
    data-test-id={dataTestId}
    {...restProps}
  >
    {children}
  </tbody>
);
